import React from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { brl } from "@/lib/format";
import { useCart } from "@/context/CartContext";

export default function ProductCard({ product, testIdPrefix = "product-card" }) {
  const { add } = useCart();
  const hasPromo = product.promo_price && product.promo_price < product.price;
  const price = hasPromo ? product.promo_price : product.price;
  const img = (product.images && product.images[0]) || "https://placehold.co/400x400/F9E1E8/C9708B?text=Lara+B.";

  return (
    <div className="group bg-white rounded-2xl p-3 border border-[#F9E1E8] shadow-sm hover:shadow-md transition-all duration-300 relative overflow-hidden flex flex-col" data-testid={`${testIdPrefix}-${product.slug}`}>
      <Link to={`/produto/${product.slug}`} className="block">
        <div className="relative aspect-square w-full rounded-xl overflow-hidden bg-[#FFF9FA] mb-3">
          <img src={img} alt={product.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ease-out" />
          <div className="absolute top-2 left-2 flex flex-col gap-1">
            {product.new_arrival && <span className="bg-[#D4B483] text-white text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full">Novo</span>}
            {hasPromo && <span className="bg-[#E57373] text-white text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full">Promoção</span>}
            {product.bestseller && <span className="bg-[#7DBE9E] text-white text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full">Mais vendido</span>}
          </div>
          {product.stock <= 0 && <div className="absolute inset-0 bg-white/80 flex items-center justify-center font-serif text-[#C9708B]">Esgotado</div>}
        </div>
      </Link>
      <Link to={`/produto/${product.slug}`} className="font-serif font-medium text-[#4A3B40] text-sm sm:text-base hover:text-[#C9708B] transition-colors line-clamp-2 min-h-[2.5rem]">
        {product.name}
      </Link>
      <div className="mt-2 flex items-end gap-2">
        <span className="font-sans font-bold text-[#C9708B] text-base sm:text-lg">{brl(price)}</span>
        {hasPromo && <span className="font-sans text-xs text-[#8C7A80] line-through">{brl(product.price)}</span>}
      </div>
      <p className="text-[11px] text-[#8C7A80] mt-0.5">ou 3x de {brl(price/3)} sem juros</p>
      <button
        onClick={() => add(product)}
        disabled={product.stock <= 0}
        className="mt-3 w-full bg-[#F9E1E8] hover:bg-[#E8A0B4] disabled:opacity-50 disabled:cursor-not-allowed text-[#C9708B] hover:text-white text-sm font-semibold rounded-full py-2 transition-all duration-300 flex items-center justify-center gap-1.5"
        data-testid={`add-to-cart-${product.slug}`}
      >
        <ShoppingBag className="w-4 h-4" /> Adicionar
      </button>
    </div>
  );
}
